export const btnCollapse = {
    methods: {
        isBtnCollapseVisible(group) {
            return (
                group.promos?.length > 2 &&
                (group.showPromosOnAcceptView ||
                    group.showPromosOnLabelsGenerateView)
            )
        },
        handleBtnCollapse(element) {
            // Wybieramy element, którego krawędź będziemy monitorować
            const promos = element.querySelector('[role="promos"]')

            // Funkcja do sprawdzania, czy dolna krawędź elementu jest poza dolną krawędzią przeglądarki
            const elementRect = element.getBoundingClientRect()
            let viewportHeight = window.innerHeight

            const selectedBar = document.querySelector('.selected')
            const collapse = element.querySelector('[role="collapse"]')
            const isModalOpened = document.querySelector('.modal-opened')

            let sBarHeight = 0
            if (selectedBar) {
                sBarHeight = selectedBar.offsetHeight
                viewportHeight = viewportHeight - sBarHeight
            }

            if (!isModalOpened && selectedBar && collapse) {
                sBarHeight += 16
                collapse.style.setProperty('--bottom-space', sBarHeight + 'px')
            } else if (collapse) {
                collapse.style.setProperty('--bottom-space', 16 + 'px')
            }

            if (promos) {
                const promosRect = promos.getBoundingClientRect()

                const header = element.querySelector('.m-promoGroup__header')
                let headerHeight = 0
                if (header) {
                    headerHeight = header.offsetHeight
                }

                if (promosRect.top < viewportHeight - headerHeight) {
                    element.classList.add('--visible')
                } else {
                    element.classList.remove('--visible')
                }
            }

            if (elementRect.bottom > viewportHeight - 16) {
                element.classList.add('--sticky')
            } else {
                element.classList.remove('--sticky')
            }
        }
    }
}
